module.exports = __webpack_public_path__ + "img/tutxtlogo.81594411.png";